class SYOSearchCustomRender {
    static customRender(item)
    {
        if(item.hasOwnProperty('recordObj'))
        {
            if(item.recordObj.hasOwnProperty('campGrade'))
            {
                if(item.recordObj.campGrade == "Trojans Sports Camps"){
                    item.grade = "Trojans Sports Camps";
                }
                else{
                    item.grade = "Grades " + item.recordObj.campGrade;
                }
            }
            if(item.recordObj.hasOwnProperty("campDates"))
            {
                if(item.recordObj.campDates !== null)
                {
                    if(item.recordObj.campDates.length > 0){
                        item.recordObj.campDates.forEach(campItem => {
                            if(campItem.date == "")
                            {
                                if(campItem.status !== null && campItem.status!= ""){
                                    campItem.date = campItem.status;
                                }
                                else{
                                    campItem.date = campItem.date;
                                }
                            }
                        })
                    }
                }
            }
        }
        return item;
    }
}

export default SYOSearchCustomRender;